export default __webpack_public_path__ + "1a5dc13e2ceade29f15fb2fc49be2ea1.jpg";